import React from 'react';
import { Card, Typography, Tag, Row, Col } from 'antd';
import { MathNumberGroup } from 'src/data/models/NumberModel';

const { Text, Paragraph } = Typography;

interface NumberGroupListProps {
    groups: MathNumberGroup[];
}

const NumberGroupList: React.FC<NumberGroupListProps> = ({ groups }) => {
    return (
        <Row gutter={[16, 16]}>
            {groups.map((group, idx) => (
                <Col key={idx} xs={24} sm={24} md={12} lg={8} xl={6}>
                    <Card
                        title={
                            <Text strong style={{ fontSize: 16 }}>
                                {group.title}
                            </Text>
                        }
                        style={{ borderLeft: `6px solid #D7ECC4`, height: '100%' }}
                    >
                        {group.description && (
                            <Paragraph type="secondary" style={{ marginBottom: 12 }}>
                                {group.description}
                            </Paragraph>
                        )}
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                            {group.numbers.map((num, index) => (
                                <Tag
                                    key={index}
                                    color="#CDF6BF"
                                    style={{
                                        borderRadius: 6,
                                        padding: '4px 8px',
                                        whiteSpace: 'normal',
                                        textAlign: 'center',
                                        minWidth: 80,
                                        border: "1px solid rgba(63, 63, 63, 0.5)"
                                    }}
                                >
                                    <div style={{ color: '#40262d' }}>
                                        <strong>{num.math}</strong> — {num.spanish}
                                    </div>
                                </Tag>
                            ))}
                        </div>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default NumberGroupList;
